<template lang="pug">
#page-top
  #wrapper
    DashboardSidebarNav
    #content-wrapper.d-flex.flex-column
      #content
        DashboardNav
        router-view(v-show="!loading")
        Spinner(v-show="loading")
        DashboardFooter
      //- #content(v-show="loading")
        Spinner
</template>

<script>
import { mapActions, mapState } from "vuex";
import DashboardSidebarNav from '@/components/DashboardSidebarNav.vue'
import DashboardNav from '@/components/DashboardNav.vue'
import DashboardFooter from '@/components/DashboardFooter.vue'
import Spinner from 'vue-simple-spinner'
import '@/assets/css/sb-admin-2.min.css'
import '@/assets/vendor/fontawesome-free/css/all.min.css'
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import '@/assets/css/sb-admin-2.min.css'
import '@/assets/vendor/fontawesome-free/css/all.min.css'
export default {
  name: 'Dashboard',
  components: {
    DashboardSidebarNav,
    DashboardNav,
    DashboardFooter,
    Spinner
  },
  data(){
    return{
      loading:true,
      intervalGo:null,
    }
  },
  computed: mapState(['allCarriers']),
  methods:{
    wizardInit(){

    }
  },
  async mounted(){
    this.intervalGo = setInterval(()=>{
      let x = this.$cookies.isKey('PLAY_SESSION')
      if(!x) {
        let path = `/login`
        if (this.$route.path !== path) this.$router.push(path)
        }
    }, 3000);
    var addressCount = await this.axios.get('/rp/server/return_address/count')  
    var addressCountNum = Number(addressCount.data.count);  
    if(!(this.$route.path == '/dashboard/plans' || this.$route.path == '/dashboard/billing' || this.$route.path == '/dashboard/userProfile' || this.$route.path == '/dashboard/install/confirmation')){
      
      if(this.allCarriers.length < 1 && addressCountNum < 1){  
        if(this.$route.path != "/dashboard/wizard/0") this.$router.push({path :'/dashboard/wizard/0'})
      }    
      else if(this.allCarriers.length < 1 && addressCountNum > 0){
        if(this.$route.path != "/dashboard/wizard/2") this.$router.push({path :'/dashboard/wizard/2'})
      }
      else if(this.allCarriers.length > 0 && addressCountNum < 1){
        if(this.$route.path != "/dashboard/wizard/1") this.$router.push({path :'/dashboard/wizard/1'})
      }
    }
    this.loading = false;
  },
  beforeRouteUpdate: function(to, from, next) {
    this.$cookies.isKey("PLAY_SESSION") ? next() : next('/login')
  },
  destroyed(){
    clearInterval(this.intervalGo)    
  }
}
</script>
<style lang="scss" scoped>
.btn-primary{
  background-color:#172b4d;
}
  #wrapper #content-wrapper{
    // width: calc(100% - 14rem);
  }
</style>